<div class="button-wrapper no-print" [class.background]="backgroundClass">
  @if (teaserText) {
    <div class="teaser" [innerHTML]="teaserText | translate"></div>
  }
  <div class="grid-x grid-margin-x">
    @if (previousLink) {
      <div class="cell shrink medium-{{mediumOffset}} large-{{largeOffset}} {{leftAlignSize}}-text-right">
        <a [routerLink]="previousLink" class="button darker-gray hollow inline-arrow-left" [title]="previousLink | translate" (click)="previousClick()"><i class="icon-arrow-left"></i>@if (previousText) {
        <span>{{previousText | translate}}</span>
      }</a>
    </div>
  }
  <div class="cell auto medium-{{mediumWidthRight}} large-{{largeWidthRight}} medium-offset-{{previousLink === null ? mediumOffset : 0}} large-offset-{{previousLink === null ? largeOffset : 0}}">
    @if (nextSubmit && nextLink) {
      <button type="submit" [class.disabled]="nextDisabled" class="button primary inline-arrow-right {{nextClass}}" (click)="nextClick()">{{nextText | translate}}</button>
    }
    @if (nextSubmit === false && nextLink) {
      <a [routerLink]="nextLink" [class.disabled]="nextDisabled" class="button primary inline-arrow-right" (click)="nextClick()">{{nextText | translate}}</a>
    }
    @if (nextSubmit === false && nextUrl) {
      <a [href]="sanitizeUrl(nextDisabled? 'javascript:void(0)' : nextUrl)" [target]="nextDisabled? '' : '_blank'" [class.disabled]="nextDisabled" class="button primary inline-arrow-right" (click)="nextClick()">{{nextText | translate}}</a>
    }
  </div>
</div>
</div>
